import { APICLIENT } from "../shared";
import { apiendpoints } from "../constants/api-endpoints";

// Contarct_List
export const getContractList = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      apiendpoints.MANAGE_CONTRACT_LIST_API
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// Contarct_By_Id
export const getContractById = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.MANAGE_CONTRACT_BY_ID_API}?id=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// Contract_Update
export const updateContract = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      apiendpoints.MANAGE_CONTRACT_UPDATE_API,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
